export const PROFILE_STATISTICS_FEATURE_KEY = 'profile-statistics';
